export default __webpack_public_path__ + "static/media/FOGPOSTER.c2b80fc3.png";